import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Step, StepLabel, Stepper, StepConnector, Typography, Grid, Button } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import LinearBuffer from './LinearBuffer';
import { Check, Error } from '@mui/icons-material';
import CustomAlert from '../../components/CustomAlert';
import CustomButton from '../../components/CustomButton';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    title_progress: {
        fontStyle: 'italic',
        textAlign: 'center',
        padding: theme.spacing(2),
    },
    text_center: {
        textAlign: 'center',
        display: 'block',
        marginTop: theme.spacing(3),
    },
}));

function OrderProgress(props) {
    const t = props.t;
    const classes = useStyles();
    const { steps, showButtonClose, title, sub_title, orderInfo, showLoadingProgress } = props;
    console.log("orderInfo OrderProgress==", orderInfo);
    console.log("props OrderProgress==", props);
    return (
        <CustomAlert
            open={props.open}
            onClose={() => props.onClose()}
            title={title ? title : t("order_status")}
            maxWidth='sm'
            title_close={t('btn_close')}
            customMessage={<>
                {(props.orderInfo.status !== 'ERROR' || showLoadingProgress) && <LinearBuffer status={props.orderInfo ? props.orderInfo.status : null} />}
                <Typography variant='body2' color='danger' className={classes.title_progress}>{sub_title ? sub_title : t('progress_order')}</Typography>
                <Stepper alternativeLabel activeStep={props.activeStep} connector={<QontoConnector />}>
                    {
                        steps.map((label, index) => {
                            const labelProps = {};
                            if (props.orderInfo.status === 'ERROR' && index === props.orderInfo.step) {
                                labelProps.error = true;
                                // labelProps.optional = (
                                //     <Typography variant="caption" color="error" className={classes.text_center}>
                                //         {props.orderInfo.message ? props.orderInfo.message : null}
                                //     </Typography>
                                // );
                                return (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={QontoStepIcon} {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            } else {
                                return (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                                    </Step>
                                );
                            }
                        })}
                </Stepper>
                <Grid item xs={12}>
                    <Typography variant="caption" color={orderInfo && orderInfo.status === 'ERROR' ? 'error' : 'success'} className={classes.text_center}>
                        {props.orderInfo.message ? props.orderInfo.message : null}
                    </Typography>
                </Grid>
                <Grid item xs={12} container spacing={1} style={{marginTop: 10, textAlign: 'right', justifyContent: 'flex-end'}}>
                {orderInfo && orderInfo.onTryAgain && <Grid item>
                        <Button variant="contained" color="primary" onClick={() => orderInfo.onTryAgain()}>{t('btn_try')}</Button>
                    </Grid>
                }
                {showButtonClose && <Grid item>
                        <Button variant="outlined" color="primary" onClick={() => props.onClose()}>{t('Close')}</Button>
                    </Grid>}
                </Grid>
            </>}
        />
    );
}

function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active, completed, error } = props;
    // console.log("QontoStepIcon props===", props);

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
            })}
        >
            {error ? <Error className={classes.error} /> : <>
                {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
            </>}
        </div>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
};

const useQontoStepIconStyles = makeStyles({
    root: {
        color: '#eaeaf0',
        display: 'flex',
        height: 22,
        alignItems: 'center',
    },
    active: {
        color: '#784af4',
    },
    circle: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        color: '#784af4',
        zIndex: 1,
        fontSize: 18,
    },
    error: {
        color: '#d32f2f',
        zIndex: 1,
        fontSize: 18,
    },
});
const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    active: {
        '& $line': {
            borderColor: '#784af4',
        },
    },
    completed: {
        '& $line': {
            borderColor: '#784af4',
        },
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
})(StepConnector);
export default (withTranslation()(OrderProgress));